module.exports = __webpack_public_path__ + "static/media/learning-5.097c5514.png";